import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import clsx from 'clsx';
import i18n from '@pureartisan/simple-i18n';
/**
 * Select element.
 *
 * Accepts an array of items, each of which serves as a dropdown item.
 *
 * @param String label   Label for select
 * @param Array items  Array of dropdown items for select
 * @param Function handleSelect Handler for dropdown item selected
 */

var Select = function Select(_ref) {
  var props = _extends({}, _ref); // console.log('Logo')


  var _useState = useState(false),
      dropdownOpen = _useState[0],
      setDropdownOpen = _useState[1];

  var toggle = function toggle() {
    return setDropdownOpen(function (prevState) {
      return !prevState;
    });
  };

  return /*#__PURE__*/React.createElement(Dropdown, {
    className: clsx("select", props.className),
    isOpen: dropdownOpen,
    toggle: toggle
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    caret: true,
    "aria-label": props.ariaLabel ? props.ariaLabel : null,
    "aria-labelledby": props.ariaLabelledby ? props.ariaLabelledby : null
  }, props.label), /*#__PURE__*/React.createElement(DropdownMenu, null, props.items.map(function (el) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      key: el.id,
      id: el.id,
      onClick: props.handleSelect,
      className: clsx(!!el.active ? 'active' : '')
    }, i18n.translate(el.label));
  })));
};

Select.defaultProps = {
  label: "Select an option",
  items: [],
  handleSelect: null
};
export default Select;